import { AxiosInstance, AxiosResponse } from 'axios';
import {
  CompteApiFactory,
  CompteParticulier,
  CompteParticulierResponse,
  CreationCompte,
  PersonnalisationApiFactory,
  PersonnalisationClient,
} from './swagger';

export interface IApi {
  postCompte(params: CreationCompte): Promise<CompteParticulier>;
  getCompte(params: string): Promise<CompteParticulierResponse>;
  ajouterAdherent(params): Promise<void>;
  getPersonnalisationPart(login): Promise<PersonnalisationClient>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const CompteApi = CompteApiFactory({}, endpoint, axiosClient);
  const personnalisationApi = PersonnalisationApiFactory({}, endpoint, axiosClient);

  const postCompte = (params): Promise<CompteParticulier> =>
    new Promise((resolve, reject) => {
      CompteApi.postCompte(params)
        .then((response: AxiosResponse<CompteParticulier>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const getCompte = (params): Promise<CompteParticulierResponse> =>
    new Promise((resolve, reject) => {
      CompteApi.getCompteByLogin(params)
        .then((response: AxiosResponse<CompteParticulierResponse>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const ajouterAdherent = (params): Promise<void> =>
    new Promise((resolve, reject) => {
      CompteApi.postAjouterAdherentByNumeroAdhesion(params.login, params.numeroAdhesion)
        .then((response: AxiosResponse<void>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const getPersonnalisationPart = (login): Promise<PersonnalisationClient> =>
    new Promise((resolve, reject) => {
      personnalisationApi
        .getPersonnalisationPart(login)
        .then((response: AxiosResponse<PersonnalisationClient>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  return {
    postCompte,
    getCompte,
    ajouterAdherent,
    getPersonnalisationPart,
  };
};

export default create;
